export default __webpack_public_path__ + "static/media/4.0ba9cf72.jpg";